import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const flexportSettings = defineIntegrationSettings({
  fields: {},
  secrets: {
    accessToken: z.string().trim().min(1, "Access token is required"),
  },
  connectOnly: {},
  computed: {},
});
